import { IProduct } from 'models';
import Product from './Product';

import * as S from './style';

interface IProps {
  products: IProduct[];
  onToggleFavourite?(product: IProduct): void;
}

const Products = ({ onToggleFavourite, products }: IProps) => {
  return (
    <S.Container>
      {products?.map((p) => (
        <Product
          product={p}
          key={p.id}
          onToggleFavourite={onToggleFavourite}
        />
      ))}
    </S.Container>
  );
};

export default Products;
